import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./PrivacyPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="farmology-privacy-page farmology-refund-page">
      <section className="privacy-hero">
        <div className="privacy-hero-grid">
          <div className="privacy-hero-content">
            <span className="privacy-eyebrow">FARMOLOGY · LEGAL</span>
            <h1>Refund Policy</h1>
            <p>
              Our refund policy is designed to be fair and transparent, ensuring
              a clear experience for every Farmology user.
            </p>
          </div>
        </div>
      </section>

      <Container className="privacy-container">
        <Box className="privacy-card">
          <Typography className="privacy-intro" variant="body1">
            At Farmology.ai, we strive to deliver high-quality SaaS solutions
            for our users. Our refund policy is designed to be fair and
            transparent, ensuring a seamless experience while protecting both
            our customers and our business.
          </Typography>

          <Typography className="privacy-section-title" variant="h6">
            Subscription Fees & Refund Eligibility
          </Typography>
          <Typography variant="body1">
            Farmology.ai offers both monthly and annual subscription plans. If
            you are unsatisfied with our service, you may request a refund under
            the following conditions:
          </Typography>
          <ul>
            <li>
              Refund requests must be made within <strong>24 Hours</strong> of
              the initial subscription purchase.
            </li>
            <li>Refunds are not applicable for renewal payments.</li>
            <li>No refunds will be provided for usage exceeding 24 Hours.</li>
            <li>
              Any promotional or discounted subscriptions are{" "}
              <strong>non-refundable</strong>.
            </li>
          </ul>

          <Typography className="privacy-section-title" variant="h6">
            Cancellation Policy
          </Typography>
          <Typography variant="body1">
            Users can cancel their subscriptions at any time from their account
            settings. Once canceled, the subscription remains active until the
            end of the billing cycle. No partial refunds are provided for unused
            portions of a subscription period.
          </Typography>

          <Typography className="privacy-section-title" variant="h6">
            Refund Process
          </Typography>
          <Typography variant="body1">
            To request a refund, contact our support team at{" "}
            <strong>info@farmologyindia.com</strong> with the following details:
          </Typography>
          <ul>
            <li>Your registered email address</li>
            <li>Transaction ID or invoice details</li>
            <li>Reason for the refund request</li>
          </ul>
          <Typography variant="body1">
            Refunds will be processed within <strong>7-10 business days</strong>{" "}
            upon approval. Refunds will be credited back to the original payment
            method.
          </Typography>

          <Typography className="privacy-section-title" variant="h6">
            Exceptions
          </Typography>
          <Typography variant="body1">
            We do not offer refunds under the following circumstances:
          </Typography>
          <ul>
            <li>Violations of our Terms of Service</li>
            <li>Failure to cancel before renewal</li>
            <li>Usage beyond the refund window</li>
          </ul>

          <Typography className="privacy-section-title" variant="h6">
            Changes to Refund Policy
          </Typography>
          <Typography variant="body1">
            Farmology.ai reserves the right to modify or update this refund
            policy at any time. Changes will be effective immediately upon
            posting on our website.
          </Typography>

          <Typography className="privacy-section-title" variant="h6">
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions about our refund policy, please contact us
            at <strong>info@farmologyindia.com</strong>.
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default RefundPolicy;
